import type { ReactNode } from 'react';
import { useAuthKit } from '../contexts/AuthProvider';

type Props = {
  /** Rendered when the visitor is not authenticated. */
  landing: ReactNode;
  /** Rendered when the visitor is authenticated. */
  children: ReactNode;
};

export function AuthGate({ landing, children }: Props) {
  const { isLoading, user } = useAuthKit();

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          background: 'var(--ink, #060E18)',
          color: 'var(--gold, #D4952B)',
          fontFamily: 'Inter, system-ui, sans-serif',
        }}
      >
        Loading…
      </div>
    );
  }

  if (!user) {
    return <>{landing}</>;
  }

  return <>{children}</>;
}
